import * as React from 'react';
import { BalanceContainer } from '../Balance';
import { CheckoutContainer } from '../Checkout';
import { MLSNPublicationBannerContainer } from '../MLSNPublicationBanner/MLSNPublicationBanner.container';
import { N1PublicationBannerContainer } from '../N1PublicationBanner/N1PublicationBanner.container';
import { ActionButtonsContainer } from '../ActionButtons';
import { AutoProlongContainer } from '../AutoProlong';
import { VisibleViolationsWarningContainer } from '../VisibleViolationsWarning';
import * as styles from './Summary.mobile.css';
import { useApplicationContext } from '../ApplicationContext';
import { SummaryMobileServicePickerWidget } from './ServicePickerWidget/SummaryMobileServicePickerWidget';

interface ISummaryMobile {
  isAutoProlongVisible: boolean;
}

export const SummaryMobile = ({ isAutoProlongVisible }: ISummaryMobile) => {
  const { config } = useApplicationContext();
  const isServicePickerWidgetEnabled = config.get<boolean>('addFormFrontend.ServicePickerWidget.isEnabled') || false;

  return (
    <div className={styles['summary']}>
      {isServicePickerWidgetEnabled ? (
        <SummaryMobileServicePickerWidget />
      ) : (
        <>
          {isAutoProlongVisible && <AutoProlongContainer />}

          <div className={styles['balance_container']}>
            <BalanceContainer />
          </div>

          <CheckoutContainer />
          <N1PublicationBannerContainer />
          <MLSNPublicationBannerContainer />
          <VisibleViolationsWarningContainer />
          <ActionButtonsContainer />
        </>
      )}
    </div>
  );
};
